<template>
  <div class="cs-bio" ref="csSynopsis">
    <div class="cs-bio--content">
      <div class="col">
        <div class="section-accent"></div>
        <IndexTitle
          v-if="heading"
          type="h3"
          index="00"
          :text="heading"
        ></IndexTitle>
        <p v-for="(text, index) in texts" :key="index" class="lead">
          {{ text }}
        </p>
      </div>
      <div class="col">
        <ul v-if="credits" class="bio-list">
          <li v-for="(item, index) in credits" :key="index">
            <Heading :text="item.heading" type="h6" class="h6"></Heading>
            <ul v-if="item.listing">
              <li
                v-for="(listItem, index) in item.listing"
                :key="index"
                class="value"
              >
                <a
                  v-if="typeof listItem === 'object'"
                  :href="listItem.href"
                  target="_blank"
                  >{{ listItem.label }}</a
                >
                <span v-else>{{ listItem }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Heading from "@/components/Heading";
import IndexTitle from "@/components/IndexTitle";
import { useTransitionComposable } from "../../composables/transition-composable";
import { ref, watch, onUnmounted } from "vue";
import { gsap } from "gsap";

const { transitionState } = useTransitionComposable();

export default {
  name: "CsSynopsis",
  components: {
    IndexTitle,
    Heading,
  },
  data() {
    return {
      inView: false,
    };
  },
  props: {
    heading: {
      type: String,
    },
    texts: {
      type: Array,
    },
    credits: {
      type: Array,
      listing: Array,
    },
  },
  setup() {
    const csSynopsis = ref(null);
    const viewable = ref(false);
    const ctx = ref();
    watch(
      [() => transitionState.transitionComplete, csSynopsis],
      (newValue) => {
        if (newValue[0] == true && csSynopsis.value) {
          const el = csSynopsis.value;

          let mm = gsap.matchMedia();
          mm.add(`(min-width: 768px)`, () => {
            ctx.value = gsap.timeline({
              scrollTrigger: {
                trigger: el,
                // start: 'top 50%', // when the top of the trigger hits the top of the viewport
                start: "top 50%",
                end: "+=1000",
                scrub: 1,
              },
            });
            ctx.value.fromTo(
              el.querySelector(".cs-bio--content .col:first-child"),
              {
                y: -40,
              },
              {
                y: -80,
                duration: 1,
              }
            );
            ctx.value.fromTo(
              el.querySelector(".cs-bio--content .col:last-child"),
              {
                y: 40,
              },
              {
                y: 80,
                duration: 1,
              }
            );
          });
        }
      },
      {
        immediate: true,
      }
    );
    onUnmounted(() => {
      ctx.value.revert(); // <- Easy Cleanup!
    });
    return { csSynopsis, viewable }; // WILL NOT WORK WITHOUT THIS
  },
};
</script>
